import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { generateLocationsBreadcrumbs, LocationTopbar } from "./";
import { ErrorPage, PageBreadcrumbProps, PageLayout } from "../../";
import { LocationService, ProviderService } from "../../../services";
import { useAsync, PageTitleProvider, usePageTitle, useUrlParams } from "../../../hooks";
import { BreadcrumbProps } from "../../../components";

function BaseLayout() {
  const locationService = new LocationService();
  const providerService = new ProviderService();

  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<PageBreadcrumbProps>();
  const { title } = usePageTitle();
  const locationId = parseInt(useUrlParams("id"));
  const providerId = parseInt(useUrlParams("providerId"));

  const { value: locationData, loading: locationLoading, error: locationError } = useAsync(() => locationService.get(locationId), [locationId]);
  const { value: providerData } = useAsync(() => providerService.get(providerId), [providerId]);

/**
   * Initialize breadcrumbs for the page depending on the route
   */
  useEffect(() => {
    if(locationId && providerId) {
      const newBreadcrumbs:BreadcrumbProps = generateLocationsBreadcrumbs(location.pathname, locationData?.name ?? "", locationId, providerData?.name, providerId);
      setBreadcrumbs(newBreadcrumbs);
    }
    else if (locationId) {
      const newBreadcrumbs:BreadcrumbProps = generateLocationsBreadcrumbs(location.pathname, locationData?.name ?? "", locationId);
      setBreadcrumbs(newBreadcrumbs);
    }
  }, [location.pathname, locationData, providerData])

  if(locationLoading) return <></>
  if(locationError){
    return <ErrorPage message={locationError.message} />
  }
  return (
    <PageLayout title={title} topbar={<LocationTopbar />} breadcrumbs={breadcrumbs}>
      <Outlet />
    </PageLayout>
  )
}

export function LocationLayout() {
  // Wrap the BaseUserLayout in a PageTitleProvider.
  // This prevents an error of the context not being initialized when the usePageTitle hook is called.
  return (
    <PageTitleProvider>
      <BaseLayout />
    </PageTitleProvider>
  );
}

export default LocationLayout
